var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-caption text-right graydefault--text mt-4"},[_vm._v("Los datos marcados con "),_c('span',{staticClass:"error--text"},[_vm._v("*")]),_vm._v(" son obligatorios")])
}]

export { render, staticRenderFns }